/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { updateIsDeleted, isDeleted, isNew, updateIsNew } from "@/api/util";
import { registerMeta } from "@/api/meta";
import {
  propertyMeta,
  typeMeta,
  typeMetaEnum,
  MetaTypesBase,
  EnumMetaType,
  MetaType,
  MetaTypeBase,
  PropertyMeta,
  AssignOptions,
  AssignOptionsRequired,
  FilterVarsType,
  getAssignOptions,
} from "../common";

/**
 *
 * @export
 * @interface InvalidSignupReportsQueueDTO
 */
export interface InvalidSignupReportsQueueDTOOptional {
  /**
   *
   * @type {string}
   * @memberof InvalidSignupReportsQueueDTO
   */
  queueId?: string;
}

export interface InvalidSignupReportsQueueDTO extends InvalidSignupReportsQueueDTOOptional {
  /**
   *
   * @type {string}
   * @memberof InvalidSignupReportsQueueDTO
   */
  queueId?: string;
}

export interface InvalidSignupReportsQueueDTOTrackedI {
  /**
   *
   * @type {string}
   * @memberof InvalidSignupReportsQueueDTO
   */
  queueId?: string;
  queueIdIsSet: boolean;
}

transformDatesMap.set(
  "InvalidSignupReportsQueueDTO",
  function (model: InvalidSignupReportsQueueDTO) {},
);

export type InvalidSignupReportsQueueDTOMetaI = MetaType<{
  //isDate: false
  //isDatetime: false
  queueId: PropertyMeta<MetaTypeBase<string>>;
}>;

export var InvalidSignupReportsQueueDTOMeta: InvalidSignupReportsQueueDTOMetaI =
  {} as InvalidSignupReportsQueueDTOMetaI;
InvalidSignupReportsQueueDTOMeta = typeMeta("InvalidSignupReportsQueueDTO", {
  queueId: propertyMeta("queueId", false, false, false, MetaTypesBase.string),
});

const metaI = InvalidSignupReportsQueueDTOMeta;

registerMeta(() => {});

export class InvalidSignupReportsQueueDTOTracked implements InvalidSignupReportsQueueDTOTrackedI {
  changeTracker: boolean = false;
  //isNew: boolean = false
  queueId__I?: string = undefined;
  queueIdIsSet: boolean = false;
  set queueId(v: undefined | string) {
    if (v !== undefined) {
      this.queueId__I = v;
      this.queueIdIsSet = true;
    } else {
      this.queueId__I = v || undefined;
      this.queueIdIsSet = false;
    }
    this.changeTracker = true;
  }
  get queueId() {
    return this.queueId__I;
  }
  constructor(
    config?: InvalidSignupReportsQueueDTOOptional,
    options?: AssignOptions,
  ) {
    if (config) {
      this.assignFrom(config, options);
    }
  }
  equals(other?: any): boolean {
    return this == other;
  }
  setIds() {}
  assignFrom(
    config: InvalidSignupReportsQueueDTOOptional,
    options?: AssignOptions,
  ): InvalidSignupReportsQueueDTOTrackedI {
    const optionsRequired = getAssignOptions(options);
    if (config.queueId && this.queueIdApplyFilter(optionsRequired.filter)) {
      this.queueId = config.queueId;
      if (optionsRequired.unassign) this.queueIdIsSet = false;
      else this.queueIdIsSet = true;
    }
    if (optionsRequired.unassignChangeTracker) this.changeTracker = false;
    if (options?.isNew !== null && options?.isNew !== undefined)
      updateIsNew(this, optionsRequired.isNew);
    return this;
  }
  shouldRemove(skipPK: boolean = true): boolean {
    if (isNew(this) && isDeleted(this)) return true;
    return (
      !this.changeTracker && !this.anySet((a, b) => !skipPK || !a.isPrimary)
    );
  }
  removeUnset(filter?: FilterVarsType): InvalidSignupReportsQueueDTOTrackedI {
    const cloned = {} as InvalidSignupReportsQueueDTOTrackedI;
    if (
      this.queueIdIsSetDeep() &&
      this.queueIdApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.queueIdIsSet = true;
      cloned.queueId = this.queueId;
    } else {
      //cloned.queueIdIsSet = false
    }
    return cloned;
  }
  unassignAll(filter?: FilterVarsType): InvalidSignupReportsQueueDTOTrackedI {
    if (!this.queueIdApplyFilter(filter)) this.queueIdIsSet = false;

    return this;
  }
  queueIdApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      InvalidSignupReportsQueueDTOMeta.queueId,
      InvalidSignupReportsQueueDTOMeta,
      this.queueId,
      this,
    );
  }
  queueIdIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.queueIdIsSet && this.queueIdApplyFilter(filter)) return true;

    return false;
  }
  anySet(filter?: FilterVarsType): boolean {
    if (this.changeTracker) return true;
    if (this.queueIdIsSetDeep(filter)) return true;
    return false;
  }
}

import { transformDatesMap } from "@/api/mappers/dtoDateMapper";
